export const INITIAL_HEARTBEAT_COUNT = 1;
export const TEN_SECONDS_IN_MS = 10 * 1000;
export const SESSION_STORAGE_KEY = 'lms-admin-heartbeat-session-storage-key';
